/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Danish (Denmark)
export default {
  'embedded-confluence-common.src.content.empty-state-description': 'Vi har ledt overalt, men den eksisterer ikke. Den er muligvis blevet slettet. Medmindre der er en slåfejl i webadressen, selvfølgelig 😉',
  'embedded-confluence-common.src.content.empty-state-header': 'Vi kunne ikke finde det, du leder efter',
  'embedded.confluence.already-logged-in-paragraph': 'Er du allerede logget ind? Prøv at genindlæse.',
  'embedded.confluence.footer.hover.text': 'Vis i Confluence',
  'embedded.confluence.footer.prefix': 'Drevet af',
  'embedded.confluence.generic-error-page.login-to-confluence-button': 'Log på Confluence',
  'embedded.confluence.login-page.login-button': 'Log ind på Confluence',
  'embedded.confluence.login-page.login-button.aria-label': 'Loginknap',
  'embedded.confluence.login-page.login-text': 'Du skal være logget ind for at kunne se denne side',
  'embedded.confluence.login-page.refresh-page-banner': 'Når du har logget ind, bør denne side genindlæses automatisk. Hvis ikke, kan du klikke her for at genindlæse',
  'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Genindlæs siden',
  'embedded.confluence.need-to-log-in-paragraph': 'Du skal være logget ind for at kunne se denne side',
  'embedded.confluence.still-having-trouble-paragraph': 'Har du stadig problemer? Sørg for, at tredjepartscookies er aktiveret, eller {link}',
  'embedded.confluence.troubleshooting-link-text': 'se denne fejlfindingsvejledning.',
  'embedded.confluence.troubleshooting-link.aria-label': 'link til fejlfindingsvejledning'
};